import { FunctionComponent } from "react"
import { NEATTData } from "src/utils/types/UserTypes"

interface IFinancialKnowledgeProps {
    financialKnowledge: NEATTData['fk']
}

const FinancialKnowledgeDisplay: FunctionComponent<IFinancialKnowledgeProps> = ({ financialKnowledge }) => (
    <div className="w-full">
        <p className="mb-3"><span className="font-medium">Attended Courses or Workshops:</span> {financialKnowledge.attendedCoursesOrWorkshops}</p>
        <p className="mb-3"><span className="font-medium">Experience Level:</span> {financialKnowledge.experienceLevel}</p>
        <p className="mb-3"><span className="font-medium">Familiar With Debt-To-Income:</span> {financialKnowledge.familiarWithD2I}</p>
        <p className="mb-3"><span className="font-medium">Financial Plan in Place:</span> {financialKnowledge.financialPlanInPlace}</p>
        <p className="mb-3"><span className="font-medium">Using Tools or Apps:</span> {financialKnowledge.usingToolsOrApps}</p>
        <p className="mb-3"><span className="font-medium">Working / Worked with Advisor:</span> {financialKnowledge.workedWithAdvisor}</p>
        <p className="mb-3"><span className="font-medium">Saving for Retirement:</span> {`${financialKnowledge.savingForRetirement.active}`}</p>
        {financialKnowledge.savingForRetirement.active && (<p className="mb-3"><span className="font-medium">Monthly Savings:</span> {financialKnowledge.savingForRetirement.amountPerMonth}</p>)}
    </div>
);

export default FinancialKnowledgeDisplay;